import React, { memo } from 'react';
import { Button, Tooltip } from 'antd';
import { AssetItemDto } from '@api/Api';
import { ReactComponent as FolderSvg } from '@assets/icons/folder.svg';
import { ReactComponent as PrivateFolderSvg } from '@assets/icons/folder-private.svg';
import { ReactComponent as DownloadInvoiceSvg } from '@assets/icons/download-invoice.svg';
import { FolderWithItems } from '@pages/Campaigns/CampaignReview/utils';
import { downloadAll } from '@helpers/download';

import TilesViewItem from './TilesViewItem';

import './TilesView.less';

type TilesViewProps = {
  onSelectFolder: (folderId: string) => void;
  onOpenAsset: (asset: AssetItemDto) => void;
  folders: FolderWithItems[];
  assetsList: AssetItemDto[];
  isOpenFolder: boolean;
};
export default memo(function TilesView({
  onSelectFolder,
  onOpenAsset,
  folders,
  assetsList,
  isOpenFolder
}: TilesViewProps) {
  return (
    <div className="campaign-review-tiles-view">
      {!!folders?.length && !isOpenFolder && (
        <div className="campaign-review-tiles-view-folders">
          <div className="campaign-review-tiles-view-label">Folders</div>
          <div className="campaign-review-tiles-view-folders-list">
            {folders.map((folder) => {
              const assetsDownloadUrls = folder.items
                .filter((asset) => !!asset.asset?.permissions.download)
                .map((asset) => asset.asset?.versions[0].sourceUrl);
              return (
                <div
                  className="campaign-review-tiles-view-folder"
                  key={folder.id}
                  onClick={() => onSelectFolder(folder.id)}
                >
                  {folder.isPrivate ? <PrivateFolderSvg /> : <FolderSvg />}
                  <div className="campaign-review-tiles-view-folder-name">
                    <Tooltip
                      title={folder.name}
                      overlayClassName="toggle_favorite_overlay toggle_favorite_overlay--small"
                    >
                      {folder.name}
                    </Tooltip>
                  </div>
                  <Button
                    type="text"
                    size="small"
                    className="campaign-review-btn-download"
                    disabled={!assetsDownloadUrls?.length}
                    icon={<DownloadInvoiceSvg />}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!assetsDownloadUrls?.length) return;
                      downloadAll(assetsDownloadUrls, `${folder.name}.zip`);
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
      {!!assetsList?.length && (
        <div className="campaign-review-tiles-view-assets">
          <div className="campaign-review-tiles-view-label">Assets</div>
          <div className="campaign-review-tiles-view-assets-list">
            {assetsList.map((item) => {
              return (
                <TilesViewItem
                  key={item.id}
                  asset={item}
                  onOpenAsset={onOpenAsset}
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
});
